import { inject, Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { LogOut, LogOutCompleted, LogOutError } from '@pages/logout/store/actions/logout.actions';
import { LogoutService } from '@pages/logout/services/logout.service';
import { HttpErrorResponse } from '@angular/common/http';

@State<void>({
  name: 'logout',
})
@Injectable()
export class LogoutState {
  private readonly logoutService = inject(LogoutService);

  @Action(LogOut)
  loadLoginConfiguration(context: StateContext<void>, { refreshToken }: LogOut): Observable<void> {
    return this.logoutService.logOut(refreshToken).pipe(
      tap(() => context.dispatch(new LogOutCompleted())),
      catchError((httpErrorResponse: HttpErrorResponse) => {
        context.dispatch(new LogOutError());

        return throwError(() => httpErrorResponse);
      })
    );
  }
}
